module.exports = __webpack_public_path__ + "static/dc-logo-eb78968b93991922c4a2ea1d8de102b4.svg";